module.exports = __webpack_public_path__ + "fonts/SofiaProBold.65e34817.ttf";